<div class="icon-wrapper" [innerHtml]="getSVG()"></div>
